export function useQuery(search) {
  return new URLSearchParams(search);
}
